import React from 'react';
export const PainSection: React.FC = () => {
  const painPoints = ['Fin de semana buscando en YouTube videos que no dan las medidas reales para el autoconstructor argentino', 'Comprás arena de más, te sobra material y perdés plata en fletes innecesarios que encarecen toda la obra', 'Miedo a que la casa "quede fea" o "se caiga" con la primera lluvia — sin saber si tu tierra sirve', 'El municipio te rechaza el proyecto porque no sabés cómo presentar una construcción en tierra', 'Los manuales técnicos parecen escritos para ingenieros, no para personas reales que quieren construir', 'Tu terreno sigue vacío. El mismo ciclo. El próximo domingo, a empezar de nuevo.'];
  return <section className="bg-white py-20 px-5 text-center" data-id="element-172" data-mp="2g9988l4d2oph">
      <h2 className="text-[clamp(22px,4vw,38px)] text-[#1A1A1A] mb-2.5 max-w-[750px] mx-auto leading-[1.3]" data-id="element-173" data-mp="2g9smnrusyuyr">
        ¿Cuántos fines de semana más vas a perder así?
      </h2>
      <p className="text-[clamp(15px,2vw,18px)] text-[#555] max-w-[680px] mx-auto mb-10 font-sans leading-[1.8]" data-id="element-174" data-mp="277jeh8n0bdoj">
        Sos alguien que sueña con construir con la tierra. Amás la idea de una
        casa sana, natural y tuya. Pero nadie te dijo que ibas a pasar los
        domingos buscando información que no conecta, mirando tutoriales sin
        medidas y llegando al lunes sin saber por dónde empezar.
        <br data-id="element-175" data-mp="i1120ritncr" />
        <br data-id="element-176" data-mp="h99d111o9rr" />
        No es falta de ganas. Es falta de un sistema.
      </p>

      <div className="max-w-[700px] mx-auto mb-10 text-left" data-id="element-177" data-mp="38xkouk9fadkf">
        {painPoints.map((point, index) => <div key={index} className={`flex items-start gap-3.5 py-4 font-sans text-[15px] text-[#333] leading-[1.5] ${index !== painPoints.length - 1 ? 'border-b border-[#F0F0F0]' : ''}`} data-id="element-178" data-mp="33yhkl219obdi" data-mpi={index}>
            <span className="text-red-main font-black text-xl shrink-0 mt-px" data-id="element-179" data-mp="3dvcltsoxcpvh">
              ❌
            </span>
            {point}
          </div>)}
      </div>

      <p className="text-[clamp(20px,3.5vw,32px)] text-green-brand font-bold max-w-[650px] mx-auto leading-[1.3]" data-id="element-180" data-mp="2l6yjj0qsz7e4">
        ¿Y si este fuera el último domingo que pasás así?
      </p>
    </section>;
};